import { Box, Stack } from "@mui/material";
import { Custom, Field, Popup, Workflow } from "components";
import { useApp, useTheme } from "contexts";
import { useNavigate } from "react-router-dom";
import { forwardRef, useState } from "react";
import { createStep } from "utils/helpers";
import { Validations } from "helpers";
import { Enums, Routes } from "utils";
import { useShare } from "hooks";
import { useWorkflow } from "contexts/components";

// icons
import { LinkRounded, SendRounded } from "@mui/icons-material";

const StepShare = forwardRef((_, ref) => {
  const navigate = useNavigate();

  const { theme } = useTheme();
  const { t } = useApp();
  const { data } = useWorkflow<Workflow.Utils.PotluckType>(); // Get updateData from context
  const { emails, handleOnChange, handleOnCopy, handleOnSubmit, users } =
    useShare(
      data.potluck._id,
      [data.potluck.created_by],
      Enums.EnumShare.Invite,
      () => setMessageOpened(true)
    );

  const [messageOpened, setMessageOpened] = useState<boolean>(false);
  const [isSubmitInvalid, setIsSubmitInvalid] = useState<boolean>(false);

  const handleOnClose = () => {
    setMessageOpened(false);
    navigate(Routes.userdashboard);
  };

  const handleOnInvite = async () => {
    setIsSubmitInvalid(() => {
      const isInvalid = emails.length === 0;
      if (!isInvalid) {
        handleOnSubmit();
      }
      return isInvalid;
    });
  };

  return (
    <>
      <Custom.Typography size={theme.font.md} weight={theme.font.bold}>
        {t.component.workflow.potluck.success_completion}
      </Custom.Typography>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.xs}>
          <Custom.Typography size={theme.font.xs} weight={theme.font.bold}>
            {t.component.workflow.potluck.contributor_invite}
          </Custom.Typography>
          <Custom.Typography
            size={theme.font.xs}
            color={theme.color.font.accent}
          >
            {t.component.workflow.potluck.share_invitation}
          </Custom.Typography>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Stack spacing={theme.spacing.sm}>
          <Field.DynamicAutocomplete
            hasError={isSubmitInvalid}
            label={t.label.email_invite}
            options={users}
            onValidate={Validations.isEmail}
            onChange={handleOnChange}
          />
          <Custom.Button
            variant="outlined"
            endIcon={<SendRounded />}
            color={theme.color.accent.color}
            onClick={handleOnInvite}
          >
            {t.action.send_invite}
          </Custom.Button>
        </Stack>
      </Box>

      <Box mt={theme.spacing.md}>
        <Custom.Button
          fullWidth
          variant="outlined"
          endIcon={<LinkRounded />}
          color={theme.color.accent.color}
          onClick={handleOnCopy}
        >
          {t.action.copy_link}
        </Custom.Button>
      </Box>

      <Popup.Message
        open={messageOpened}
        title={t.component.popup.message.title}
        headline={t.component.popup.message.headline}
        onClose={handleOnClose}
      />
    </>
  );
});

export default createStep<Workflow.Utils.PotluckType>(StepShare);
